import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../menu/header2';

import screen1 from '../../../src/assets/lotus12.png';
import screen2 from '../../../src/assets/lotus21.png';
import screen3 from '../../../src/assets/mobilelotus.png';
import awakening from '../../../src/assets/awakening.mp4';
import sacred from '../../../src/assets/sacred.mp4';
import legendary from '../../../src/assets/legendary.mp4';
import wild from '../../../src/assets/wild.mp4';

const LotusFarm = () => {
  return (
    <>
      {/* Render the Header outside the main container */}
      <Header />
      
      {/* Main container with top padding to push content below the fixed header */}
      <Container
        fluid
        style={{
          backgroundColor: '#ffffff',
          padding: '20px',
          paddingTop: '100px' // Adjust to match your header's height
        }}
      >
        <Row>
          {/* Left Column */}
          <Col md={7}>
            <img
              src={screen1}
              alt="ChurroSwap"
              style={{
                width: '80%',
                height: 'auto',
                paddingBottom: '2em'
              }}
            />
            {/* First Row of Videos */}
            <Row style={{ marginBottom: '20px' }}>
              <Col style={{ marginRight: '10px' }}>
                <video src={awakening} controls style={{ height: '20em' }} />
              </Col>
              <Col style={{ marginRight: '10px' }}>
                <video src={sacred} controls style={{ height: '20em' }} />
              </Col>
            </Row>
            {/* Second Row of Videos */}
            <Row style={{ marginBottom: '20px' }}>
              <Col style={{ marginRight: '10px' }}>
                <video src={wild} controls style={{ height: '20em' }} />
              </Col>
              <Col style={{ marginRight: '10px' }}>
                <video src={legendary} controls style={{ height: '20em' }} />
              </Col>
            </Row>
            <img src={screen3} alt="ChurroSwap" style={{ height: '50em' }} />
            <img
              src={screen2}
              alt="ChurroSwap"
              style={{
                width: '80%',
                height: 'auto',
                paddingBottom: '2em'
              }}
            />
          </Col>

          {/* Right Column */}
          <Col md={5} style={{ color: 'black' }}>
            <h1>Lotus Farm</h1>
            <h3>Fractionalized Ethereum Staking</h3>
            <h3>
              <a href="https://www.lotusfarm.io">lotusfarm.io</a>
            </h3>
            <p>
              Lotus Farm is an Ethereum NFT staking platform that fractionalizes Ethereum nodes and disburses ETH staking rewards to everyone that is an NFT holder.
            </p>
            <h3>Key Features</h3>
            <ul>
              <li>Simplified node ownership</li>
              <li>Fractionalized ETH staking pools</li>
              <li>NFT staking with automatic metadata upgrades</li>
              <li>Central dApp giving out exact percent rewards according to rank of an NFT</li>
            </ul>
            <h3>Challenges</h3>
            <p>
              Our client needed to stake ERC1155 NFT’s into ERC721s. Those ERC721s would then need to be staked inside a central dApp. Whenever those ERC1155s reached a certain threshold in staking within the ERC721s they would then have their metadata change automatically. In simple terms, the client wanted to stake petals inside flowers. The flowers would change based on the amount of petals staked within. Each petal was worth 1 ETH and a maximum of 32 petals could be staked. The main challenge was ensuring that all of these NFTs communicated with each other and that their metadata updated accordingly.
            </p>
            <br />
            <p>
              Another challenge was the central dApp. We needed to make sure that the dApp would accept ETH from the node and disburse ETH based on the rank of the flower. Flowers give ETH rewards in percentages of 25, 50, 75, and 100, which correspond to the rank of the flower. We secured the dApp by ensuring that only NFT holders could collect rewards. Additionally, the dApp pays out interest in the form of a platform token to anyone staking.
            </p>
            <br />
            {/* Two Rows with Two Columns Each */}
            <Row style={{ marginBottom: '20px' }}>
              <Col style={{ marginRight: '10px' }}>
                <h3>MVP Completion Date</h3>
                <p>2023</p>
              </Col>
              <Col style={{ marginRight: '10px' }}>
                <h3>Client</h3>
                <p>Lotus Farm</p>
              </Col>
            </Row>
            <Row style={{ marginBottom: '20px' }}>
              <Col style={{ marginRight: '10px' }}>
                <h3>Skills Used</h3>
                <p>Smart Contract development, Website development, Branding, Brand Strategy, Tokenomics, Finance, 3D Content Design</p>
              </Col>
              <Col style={{ marginRight: '10px' }}>
                <h3>Technology Used</h3>
                <p>Solidity for Smart Contracts, React, Adobe Creative Cloud</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default LotusFarm;
